import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Alert, Button, Form, Spinner, Col } from 'react-bootstrap';
import { Page } from '../../../hoc/Page.jsx';
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import { changeUserPassword } from '../../../actions/user';
import validate from './validate';
import asyncOldPasswordValidate from './asyncValidate';
import PasswordField from './PasswordField.jsx';
import notifier from '../../../../_utils/notifier';


const PasswordChange = ({ handleSubmit, anyTouched, submitting, invalid }) => {

  const handleFormSubmit = async (formData) => {
    const response = await handleSubmit(formData);
    if (response.message){
      notifier.success(response.message);
    }
  }

  return <div>
    <Form onSubmit={ handleFormSubmit } className={ '' + (anyTouched ? ' was-validate' : '') }>

      <Form.Row>
        <Col md={9} sm={12}>
          <PasswordField label={ gettext('Старый пароль') }
                         placeholder={ gettext('Старый пароль') }
                         name='old_password'/>
        </Col>
      </Form.Row>

      <Form.Row>
        <Col md={9} sm={12}>
          <PasswordField label={ gettext('Новый пароль') }
                         placeholder={ gettext('Новый пароль') }
                         name='new_password'/>
        </Col>
      </Form.Row>

      <Form.Row>
        <Col md={9} sm={12}>
          <PasswordField label={ gettext('Подтверждение нового пароля') }
                         placeholder={ gettext('Подтверждение нового пароля') }
                         name='new_password2'/>
        </Col>
      </Form.Row>

      <Form.Row>
        <Col md={9} sm={12}>
          { (anyTouched && invalid) &&
            <Alert variant='danger' className='mt-3'>{ gettext('Проверьте правильность заполнения формы.') }</Alert>
          }

          <div className='text-lg-right mt-3'>
            <Button variant="primary" type="submit" disabled={ submitting || invalid }
                    className='mt-2 mt-md-0'>
              { submitting
                ? <>
                    <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" className='mr-1'/>
                    { gettext('Сохраняется') + '...' }
                  </>
                : gettext('Сохранить') }
            </Button>
          </div>
        </Col>
      </Form.Row>
    </Form>
  </div>
}

PasswordChange.PropTypes = {
  anyTouched: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,

  handleSubmit: PropTypes.func.isRequired,
}

export default compose(
  connect(null, { onSubmit: changeUserPassword }),
  LoginRequired,
  Page,
  reduxForm({
    form:'passwordForm',
    validate,
    asyncValidate: asyncOldPasswordValidate,
    asyncBlurFields: ['old_password'],
  }),
)(PasswordChange);

